// Danish

export default {

  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `åben indtil ${date}` : ''),
    },

    interview: {
      title: 'Optag videointerview svar',
      submit: 'Send svarene, og afslut videointerviewet',
      continueLater: 'Fortsæt senere',
      startInterview: 'Start jobsamtale ',
      duplicateError: 'Du har allerede deltaget i denne jobsamtale. Du har modtaget en mail fra invitations@recright.com som indeholder et link, der kan bruges til at fortsætte interviewet.',
      confirmSubmitHeader: 'Du har ikke besvaret alle spørgsmål i et interviewet',
      confirmSubmitContent: 'Ønsker du virkelig at afslutte interviewet?',
      confirmSubmitContentWarning: 'Efter dette, kan du ikke fuldføre dine svar.',
      submitInterviewHeader: 'Indsend dine svar på interviewet',
      submitInterviewContent: 'Er du sikker på, at du vil indsende dit interview?',
      confirmSubmitButton: 'Send svar og fuldfør jobsamtale',
      preview: 'Du kan se spørgsmålene i videoen her.',
      withdrawLink: 'Ikke interesseret i denne stilling længere? Meld dig ud af processen her.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      city: 'By',
      link: 'Link',
      legendBasicInfo: 'Grundlæggende oplysninger',
      placeholderName: 'Indtast dit navn',
      placeholderEmail: 'Indtast din e-mail',
      placeholderPhone: 'Indtast dit telefonnummer',
      placeholderCity: 'Indtast din nuværende hjemby',
      placeholderLink: 'Indtast link',
      legendAttachments: 'Vedhæftede filer',
      legendAdditionalFields: 'Yderligere oplysninger',
      required: '* Felterne mærket med en stjerne er obligatoriske.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Lyd',
        video: 'Video',
        yes: 'Ja',
        no: 'Nej',
        supported: 'Understøttet',
        quality: 'Kvalitet',
        header: 'Test af netværksforbindelse og enhed',
        description: 'Nu kører vi en test for at sikre, at din netværksforbindelse og den hardware, du skal bruge til interviewet (kamera og telefon), virker korrekt. Når du anmodes om det, så giv tilladelse til, at testen må bruge både dit kamera og din mikrofon, og sørg for, at dit kamera ikke er dækket. Testen tager omkring 30 sekunder. Vi anbefaler, at du taler under hardwaretesten.',
        inProgress: 'Test er i gang ...',
        networkTestResults: 'Resultater af netværkstest',
        qualityTestResults: 'Resultater af kvalitetstest',
        testPassedQuality: 'Kvalitetstest bestået',
        testFailedQuality: 'Kvalitetstest ikke bestået',
        testPassedNetwork: 'Netværkstest bestået',
        testFailedNetwork: 'Netværkstest ikke bestået',
        startTest: 'Start testen',
        startInterview: 'Start jobsamtalen',
        testAgain: 'Test igen',
        confirmWarning: 'Når din videosamtale starter, vil du automatisk få vist dit første spørgsmål i jobsamtalen. Når du har set spørgsmålet, sendes du videre til forberedelsen.',
        confirmTitle: 'Din jobsamtale starter snart',
        confirmText: 'Du har lidt tid til at forberede dit svar, inden hvert spørgsmål stilles. Efter forberedelsen har du et fastsat tidsrum til at besvare spørgsmålet. Bemærk, at du kan sende dit svar, så snart du er klar – sågar inden den fast definerede svartid er udløbet.',
        confirmText2: 'Når du har indsendt dit svar, sendes du videre til næste spørgsmål, indtil der ikke er flere spørgsmål.',
        confirmText3:
          'Bemærk, at når du har registreret dit svar på et spørgsmål, har du 30 sekunder til at tage din besvarelse om, hvis det er tilladt at tage besvarelsen om. Hvis du ikke begynder at tage besvarelsen om i løbet af disse 30 sekunder, vil dit nuværende svar automatisk blive sendt, og det næste spørgsmål vil blive vist.',
        goodLuck: 'Tag en dyb indånding, så skal du nok klare det. Held og lykke!',
        qualityRating: {
          excellent: 'Glimrende',
          good: 'God',
          fair: 'Rimelig',
          poor: 'Ringe',
          bad: 'Dårlig',
        },
      },
      questionAnswerView: {
        title: title => `Svar til jobsamtalen ${title}`,
        question: 'Spørgsmål',
        submitAndNext: 'Indsend og næste',
        submitSuccess: 'Video indsendt!',
        skipText: 'Start optagelse',
        stop: 'Stop',
        submitAndFinish: 'Indsend og afslut jobsamtalen',
        retake: 'Optag igen',
        take: 'Optagelse',
        takesLeft: 'Optagelser tilbage',
        skipTextQuestion: 'Klar? Fortsæt',
        retakeConfirmTitle: 'Er du sikker på, at du vil tage din besvarelse af dette spørgsmål om?',
        retakeConfirmSubmit: 'Ja, tag om',
        submitInfoForward: 'Indsender automatisk dit nuværende svar, og fortsætter om',
        submitInfoForward2: 'sekunder',
        nonAnswerableText: 'Denne meddelelse kræver intet svar. Du føres direkte til det næste spørgsmål efter denne meddelelse.',
        nonAnswerableVideo: 'Denne video kræver intet svar. Du føres direkte til det næste spørgsmål efter denne video.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Du har ${answerMinutes} minutter og ${answerSeconds} sekunder til at besvare spørgsmålet.`,
      },
      publisher: {
        toNextQuestion: timer => `Går videre til det næste spørgsmål om ${timer}`,
        recordingStarts: timer => `Optagelsen starter om ${timer}`,
      },
      errors: {
        tooManyConnections: 'Denne forbindelse blev lukket, fordi du allerede har en forbindelse åben i en anden fane eller et andet vindue.',
        unsupportedBrowser: 'Desværre understøttes denne handling ikke i din browser. Brug en anden browser.',
        networkError: 'Ingen internetforbindelse.',
        reconnecting: 'Forbindelsen blev afbrudt. Prøv at oprette forbindelse igen.',
        generalError: 'Der opstod en fejl. Opdater siden, og prøv igen.',
        allowMediaDevicesError: 'Denne handling kunne ikke få adgang til medieenheder (kamera eller mikrofon). Sørg for, at du har givet browseren tilladelse til at bruge dit kamera og din mikrofon.',
        noAvailableDevicesError: 'Vi kunne ikke finde et kamera eller en mikrofon.',
        initPublisherError: 'Handlingen mislykkedes på grund af en fejl. Sørg for, at du har tilladt browseren at bruge dit kamera og din mikrofon, og at de ikke bruges af et andet program, og prøv derefter igen.',
      },
      browserInfo: {
        browserSupportTitle: 'Browserunderstøttelse',
        supportedBrowsers: 'Denne test og jobsamtale understøtter de nyeste versioner af Chrome, Firefox, Safari og Edge.',
        mobileSupported: 'Understøttede browsere på mobil',
        android: 'Android: Google Chrome (nyeste version), Firefox (nyeste version)',
        iOS: 'iOS: Safari (nyeste version)',
        latestVersion: 'Sørg for, at du bruger den nyeste version af browseren. Dette sikrer, at alt virker perfekt.',
        freezeInstruction: 'Hvis videooptagelsen ikke starter, eller optagelsesskærmen forbliver sort, skal du opdatere siden.',
        unsupportedOnIos: 'Det ser ud til, at du bruger en browser, der ikke understøttes på iOS. Brug Safari.',
        ieUnsupported: 'Det ser ud til, at du bruger Internet Explorer. Desværre understøttes Internet Explorer ikke til denne test eller jobsamtale. Brug en anden browser.',
        qualityTestNotSupported: 'Desværre er test af hardwaren ikke understøttet i den browser, du bruger. Du kan fortsætte jobsamtalen uden at teste lyd- og videokvalitet, eller du kan bruge en anden browser.',
      },
      reconnectSuccess: 'Det lykkedes at oprette forbindelse igen!',
      continue: 'Fortsæt',
    },

    withdraw: {
      title: 'Ikke interesseret i denne stilling længere?',
      description: 'Meld dig ud af rekrutteringsprocessen.',
      buttonText: 'Meld dig ud af rekrutteringsprocessen',
      thankYouTitle: 'Tak!',
      thankYouText: 'Du har nu oplyst rekrutteringsmedarbejderen, at du ikke længere er interesseret i denne stilling.',
      confirm: 'Er du sikker på, at du ønsker at melde dig ud af rekrutteringsprocessen? Når du har meldt dig ud, kan du ikke længere besvare denne eller andre jobsamtaler i forbindelse med denne stilling.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Indsend',
      continue: 'Fortsæt',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Tak for din video svar! Vi vil være i kontakt med dig i nær fremtid!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Tak for din deltagelse i videointerviewet!',
      reopenDescription: 'Lukkede du denne jobsamtale ved et uheld? Bare rolig, du kan åbne den igen ved at klikke på knappen nedenfor!',
      reopenButtonText: 'Åbn jobsamtale igen',
      description1: 'Dejligt! Du har svaret på alle spørgsmålene, og de er nu blevet sendt til modtageren.',
      descriptionsupport: mailto => `Hvis du har afsluttet dette interview ved et uheld, kan du kontakte vores kundeservice ${mailto} og vi vil genåbne dit interview.`,
      descriptionfeedback: 'Din oplevelse er vigtig for os! Hvordan oplevede du at deltage i et videointerview? Hvordan ville du forbedre vores service? Giv din feedback via dette link.',
      feedbackbutton: 'Giv os feedback',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },

    messages: {
      title: 'Personlig meddelelse',
    },

    closed: {
      title: 'Interview er afsluttet',
      description: 'Videointerviewet du var inviteret til er allerede afsluttet.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },

    saved: {
      title: 'Dit videointerview er nu gemt!',
      description: 'Når du ønsker at fortsætte videointerviewet, skal du bruge det link, du tidligere har modtaget per e-mail. Hvis du allerede har indspillet videosvar, vil de fortsat være der, når du vender tilbage! Held og lykke med din jobsøgning!',
      remember: 'Husk at sende svarene, når du er færdig med interviewet.',
      deleteHistory: 'Hvis du laver videointerviewet på en offentlig computer, skal du huske at rydde din browserhistorik for at sikre, at din video forbliver privat.',
    },
    unpublished: {
      title: 'Jobsamtalen er ikke åbnet endnu',
      publishTime: publishTime => `Jobsamtalen åbner ${publishTime}`,
    },
  },
}
